/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

import {useEffect} from "react"; // Importing React hooks for managing state and side effects
import {Contract} from "../../../../../models/Contract"; // Importing the Contract model to define initial contract data structure
import {UpdateContractV1} from "../../../../../reduxToolkit/EmployeeContractors/EmployeeContractorsApi"; // Importing API methods for creating and updating contracts
import {toast} from "react-toastify"; // Importing the toast notification library for displaying success/error messages
import {GetContractByIdV2} from "../../../../../reduxToolkit/Contractor/ContractorApi";
import {errorMsg} from "../../../../../Apis/functions"; // Importing the API method to get a contract by its ID

// Main component for updating contracts
const UpdateContractApp = ({ t, dispatch, navigate, contractId, contract, setContract, isValidStartDate, isValidEndDate,
                               setEmptyFields,  modified, setModified}) => {
    // Function to handle form submission (create or update contract)
    const handleSubmit = () => {
        // Check if all required fields are filled and the dates are valid
        if (contract.contractorId && contract.startDate && isValidStartDate && contract.endDate && isValidEndDate) {
            setEmptyFields(false); // Reset the empty fields error

            // Prepare the data to send based on the contract state
            const dataToSend = Contract.toRegister(contract);

            // Replace empty fields with null
            Object.keys(dataToSend).forEach((key) => {
                if (dataToSend[key] === '') {
                    dataToSend[key] = null;
                }
            });

            // If it's an update, dispatch the update contract action
            dispatch(UpdateContractV1(contract)).then(
                ({
                     payload: {
                         data: { success, code },
                     },
                 }) => {
                    if (success) {
                        toast.success(t('has_been_updated_successfully')); // Display success message
                        setModified(true);
                    } else {
                        errorMsg(code)
                    }
                }
            );
        } else {
            setEmptyFields(true); // If fields are empty, set the error state to true
        }
    };

    // useEffect hook to dispatch actions on component mount
    useEffect(() => {
       getContractInfo()
    }, []);

    useEffect(() => {
        if(modified){
            getContractInfo();
            setModified(true);
        }
    }, [modified]);

    const getContractInfo = () => {
        dispatch(GetContractByIdV2(contractId)).then(
            ({
                 payload: {
                     data: { data, success },
                 },
             }) => {
                if (success === true) {
                    setContract((prev) => ({
                        ...prev,
                        ...data // Merge the fetched contract data with the existing state
                    }));
                }
            }
        );
    }

    // Return values to be used by the component's UI
    return {
        handleSubmit,
    };
}

export default UpdateContractApp; // Export the CreateContractApp component to be used elsewhere
